import { render, staticRenderFns } from "./VContentCard.vue?vue&type=template&id=4141fe09&scoped=true&"
import script from "./VContentCard.vue?vue&type=script&lang=js&"
export * from "./VContentCard.vue?vue&type=script&lang=js&"
import style0 from "./VContentCard.vue?vue&type=style&index=0&id=4141fe09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141fe09",
  null
  
)

export default component.exports